var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupplierFilterInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/SupplierHide_24dp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.17785 5.17785L0 4L1.5 2.5L19.5 20.5L18 22L13 17H9C9 18.66 7.66 20 6 20C4.34 20 3 18.66 3 17H1V6C1 5.70741 1.06368 5.42897 1.17785 5.17785ZM3 7V15H3.78C4.33 14.39 5.11 14 6 14C6.89 14 7.67 14.39 8.22 15H11L3 7ZM6 18C5.45 18 5 17.55 5 17C5 16.45 5.45 16 6 16C6.55 16 7 16.45 7 17C7 17.55 6.55 18 6 18Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.075 4L8.125 6H15V12.7073L18.5353 16.1564C18.6521 16.2309 18.7526 16.329 18.8299 16.4438L20.7142 18.2821C20.8975 17.8936 21 17.459 21 17H23V12L20 8H17V4H6.075ZM19.5 9.5L21.46 12H17V9.5H19.5Z",
    fill: "#999999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierFilterInactive);
export default __webpack_public_path__ + "static/media/supplier-filter-inactive.d3d2f4e0.svg";
export { ForwardRef as ReactComponent };